module.exports = __webpack_public_path__ + "media/images/badge-delivery-8f3ce14b4a2c3ffea77058a744e7a64d.svg";